<template>
    <!-- if color -->
    <span v-if="child.color" aria-labelledby="color" aria-label="color" :title="child[finalizedNameKey]"
    class="w-[1.310rem] h-[1.310rem] md:w-[1.2rem] md:h-[1.2rem] 3xl:w-[1.42rem] 3xl:h-[1.42rem] rounded-full overflow-hidden ">
        <span :style="{ backgroundColor: child.color }"
        class="inline-block w-full h-full rounded-full"></span>
    </span>
    <!-- if text -->
    <span v-else :aria-label="child[finalizedNameKey]" class="bg-[#E3F2FD] text-primary py-1.5 px-3 rounded-lg border border-[#BBDEFB] whitespace-nowrap">
        {{ child[finalizedNameKey] }}
    </span>
</template>
  
<script>
export default {
    setup() {
        const usedCookieLanguage = useCookie('localStorageCopy')?.value?.language || 'ar';
        return {
            usedCookieLanguage
        }
    },
    props: {
        child: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },
    computed: {
        finalizedNameKey() {
            return this.nameKey || `name_${this.usedCookieLanguage}`;
        },
    }
};
</script>
  
<style></style>